import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import undoable, { includeAction } from "redux-undo";

import userReducer from "./reducers/userReducer";
import dataReducer from "./reducers/dataReducer";
import uiReducer from "./reducers/uiReducer";
import designReducer from "./reducers/designReducer";
import templatesReducer from "./reducers/templatesReducer";

const middleware = [thunk];

const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const reducers = combineReducers({
  user: userReducer,
  data: dataReducer,
  UI: uiReducer,
  design: designReducer,
  templates: undoable(templatesReducer, {
    limit: 10,
    ignoreInitialState: true,
    initTypes: ["RESET_UNDO_REDO"],
    debug: false,
    filter: includeAction([
      "UPDATE_LAYER",
      "ADD_LAYER",
      "UPDATE_LAYERS",
      "UPDATE_DESIGN_TEMPLATE",
    ]),
  }),
});

export default function configureStore(preloadedState = {}) {
  return createStore(
    reducers,
    preloadedState,
    composeEnhancers(applyMiddleware(...middleware))
  );
}
